import {
    AfterViewInit,
    Component,
    Inject,
    Optional,
    OnInit,
    ViewChild,
    Input,
    Output,
    EventEmitter,
} from '@angular/core';
import {
    MatDialog,
    MatDialogRef,
    MAT_DIALOG_DATA,
} from '@angular/material/dialog';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { MatChipInputEvent } from '@angular/material/chips';
import { MatTable } from '@angular/material/table';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { TranslateService } from '@ngx-translate/core';
import { MatCalendar } from '@angular/material/datepicker';
import {
    DateAdapter,
    MAT_DATE_FORMATS,
    MatDateFormats,
} from '@angular/material/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import {
    FormBuilder,
    FormGroup,
    FormControl,
    Validators,
} from '@angular/forms';
import { MatStepper } from '@angular/material/stepper';
import { SujetoObligado } from 'app/main/models/sujeto-obligado.model';
import { TipoSujetoObligadoService } from 'app/main/services/tipo-sujeto-obligado.service';
import { TipoDocumentoService } from 'app/main/services/tipo-documento.service';
import { PaisService } from 'app/main/services/pais.service';
import { SectorActividadService } from 'app/main/services/sector-actividad.service';
import { ProfesionService } from 'app/main/services/profesion.service';
import { PersonaFisica } from 'app/main/models/persona-fisica.model';
import { PersonaJuridica } from 'app/main/models/persona-juridica.model';
import { Contacto } from 'app/main/models/contacto.model';
import { MonedaService } from 'app/main/services/moneda.service';
import { TipoOperacionService } from 'app/main/services/tipo-operacion.service';
import { MarcoDeReferenciaService } from 'app/main/services/marco-de-referencia.service';
import { DialogBoxDestinatariosComponent } from './destinatario-dialog-box.component';
import { DialogBoxTreeComponent } from '../formulario/dialog/dialog-box-tree.component';
import { Formulario } from 'app/main/models/formulario.model';
import {
    MatTreeFlatDataSource,
    MatTreeFlattener,
} from '@angular/material/tree';
import { FlatTreeControl } from '@angular/cdk/tree';
import { FormularioItem } from 'app/main/models/formulario-item.model';
import { FormularioService } from 'app/main/services/formulario.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { UtilsService } from 'app/main/services/utils.service';
import { ClienteService } from 'app/main/services/cliente.service';
import { Cliente } from 'app/main/models/cliente.model';
import { DecimalPipe } from '@angular/common';
import { DebidaDiligencia } from 'app/main/models/debida-diligencia.model';
import { DebidaDiligenciaService } from 'app/main/services/debida-diligencia.service';
import { PonderacionDeRiesgosService} from '../../../services/ponderacion-de-riesgos.service';
import { OrigenDeFondosService} from '../../../services/origen-de-fondos.service';

interface ExampleFlatNode {
    expandable: boolean;
    name: string;
    level: number;
}

@Component({
    selector: 'app-dialog-box-debida-diligencia',
    templateUrl: './dialog-box-debida-diligencia.component.html',
    styleUrls: ['./dialog-box-debida-diligencia.component.scss'],
    providers: [DecimalPipe],
})
export class DialogBoxDebidaDiligenciaComponent {


    @Output() eventoDesdePadre: string;

    private _transformer = (node: FormularioItem, level: number) => {
        return {
            expandable: !!node.sentencias && node.sentencias.length > 0,
            name: node.nombre,
            level: level,
            descripcion: node.descripcion,
        };
    }

    tipos = [
        { nombre: 'Persona física', value: 'PERSONA_FISICA' },
        { nombre: 'Persona jurídica', value: 'PERSONA_JURIDICA' },
    ];

    displayedColumnsDestinatarios: string[] = [
        'nombre',
        'apellido',
        'correoElectronico',
        'action',
    ];
    sujetoObligado: SujetoObligado;
    action: string;
    LOCAL_DATA: any;
    totalCalculo: number = 0;
    GENERAL_DATA: SujetoObligado = new SujetoObligado({});
    visible = true;
    removable = true;
    addOnBlur = true;
    isLinear = false;
    clientes = [];
    ponderacionesDeRiesgos = [];

    stepClients = false;

    // Estructura para el formulario
    isFormLoaded = false;
    treeControl = new FlatTreeControl<ExampleFlatNode>(
        (node) => node.level,
        (node) => node.expandable
    );

    treeFlattener = new MatTreeFlattener(
        this._transformer,
        (node) => node.level,
        (node) => node.expandable,
        (node) => node.sentencias
    );

    dataSource = new MatTreeFlatDataSource(
        this.treeControl,
        this.treeFlattener
    );

    razonSocialPais = null;
    tiposDocumentos = [];
    tiposSujetos = [];
    tiposSectorIndustrial = [];
    tiposProfesiones = [];
    paises = [];
    origenFondos = [];
    monedas = [];
    tiposDeOperacion = [];
    formularios = [];
    showNewClient = false;

    firstFormGroup = this._formBuilder.group({
        firstCtrl: ['', Validators.required],
    });
    secondFormGroup = this._formBuilder.group({
        secondCtrl: ['', Validators.required],
    });

    constructor(
        public dialogRef: MatDialogRef<DialogBoxDebidaDiligenciaComponent>,
        public translate: TranslateService,
        public dialog: MatDialog,
        private _formBuilder: FormBuilder,
        private serviceTipoSujetoObligado: TipoSujetoObligadoService,
        private serviceTipoDocumento: TipoDocumentoService,
        private servicePais: PaisService,
        private serviceSectorIndustrial: SectorActividadService,
        private serviceProfesion: ProfesionService,
        private serviceMoneda: MonedaService,
        private serviceTiposOperacion: TipoOperacionService,
        private serviceMarcoDeReferencia: MarcoDeReferenciaService,
        private service: FormularioService,
        private serviceDD: DebidaDiligenciaService,
        public utils: UtilsService,
        private _snackBar: MatSnackBar,
        private decimalPipe: DecimalPipe,
        private ponderacionDeRiesgosService: PonderacionDeRiesgosService,
        private origenDeFondosService: OrigenDeFondosService,
        // @Optional() is used to prevent error if no data is passed
        @Optional() @Inject(MAT_DIALOG_DATA) public data: any
    ) {
        this.sujetoObligado = data.sujetoObligado;
        this.clientes = data.clientes;
        delete data.clientes;
        this.LOCAL_DATA = { ...data };
        this.LOCAL_DATA.beneficiario = new Cliente({});

        if (data.action === 'Update') {
            this.serviceDD
                .get(this.LOCAL_DATA.id)
                .pipe()
                .subscribe((req) => {
                    this.LOCAL_DATA = req.body;
                    this.LOCAL_DATA.fechaVencimiento = new Date(
                        this.LOCAL_DATA.fechaVencimiento
                    );
                    this.LOCAL_DATA.beneficiario = new Cliente({});
                    this.loadLocalDataBeneficiario();
                });
        }

        if (this.LOCAL_DATA.cliente != null) {
            this.stepClients = true;
        } else {
            this.showNewClient = true;
            this.LOCAL_DATA.cliente = new Cliente({});
            this.LOCAL_DATA.cliente.sujetoObligado = null;
        }

        if (this.LOCAL_DATA.destinatarios == null) {
            this.LOCAL_DATA.destinatarios = [];
        }
        this.action = data.action;

        this.serviceTipoSujetoObligado
            .getList()
            .pipe()
            .subscribe((req) => {
                this.tiposSujetos = req.body.map((tipo) => {
                    console.log(tipo);
                    return {
                        id: tipo.id,
                        nombre: tipo.nombre,
                    };
                });
            });

        this.serviceTipoDocumento
            .getList()
            .pipe()
            .subscribe((req) => {
                this.tiposDocumentos = req.body.map((tipo) => {
                    console.log(tipo);
                    return {
                        id: tipo.id,
                        nombre: tipo.nombre,
                        tipo: tipo.tipo,
                    };
                });
            });

        this.servicePais
            .getList()
            .pipe()
            .subscribe((req) => {
                this.paises = req.body.map((tipo) => {
                    console.log(tipo);
                    return {
                        id: tipo.id,
                        nombre: tipo.nombre,
                        factorDeRiesgo: tipo.factorDeRiesgo
                    };
                });
            });

        this.serviceSectorIndustrial
            .getList()
            .pipe()
            .subscribe((req) => {
                this.tiposSectorIndustrial = req.body.map((tipo) => {
                    console.log(tipo);
                    return {
                        id: tipo.id,
                        nombre: tipo.nombre,
                        sectorDeActividad: tipo.sectorDeActividad,
                        factorDeRiesgo: tipo.factorDeRiesgo

                    };
                });
            });

        this.serviceProfesion
            .getList()
            .pipe()
            .subscribe((req) => {
                this.tiposProfesiones = req.body.map((tipo) => {
                    console.log(tipo);
                    return {
                        id: tipo.id,
                        nombre: tipo.nombre,
                    };
                });
            });

        this.serviceMoneda
            .getAll(0, 1000)
            .pipe()
            .subscribe((req) => {
                this.monedas = req.body.map((moneda) => {
                    console.log(moneda);
                    return {
                        id: moneda.id,
                        nombre: moneda.nombre,
                        simbolo: moneda.simbolo,
                        factorDeRiesgo: moneda.factorDeRiesgo
                    };
                });
            });

        this.serviceTiposOperacion
            .getAllByTipoSujetoObligado(this.sujetoObligado.tipoSujetoObligado.id, 0, 1000)
            .pipe()
            .subscribe((req) => {
                this.tiposDeOperacion = req.body.map((tipo) => {
                    console.log(tipo);
                    return {
                        id: tipo.id,
                        nombre: tipo.nombre,
                        factorDeRiesgo: tipo.factorDeRiesgo
                    };
                });
            });


        this.service
            .getAll(0, 1000)
            .pipe()
            .subscribe((req) => {
                this.formularios = req.body.map((tipo) => {
                    console.log(tipo);

                        return {
                            id: tipo.id,
                            nombre: tipo.nombre,
                            tipo: tipo.tipo,
                        };

                });
            });

        this.ponderacionDeRiesgosService.
        getAll(0, 1000).pipe().
        subscribe((req) => {
            this.ponderacionesDeRiesgos = req.body.map((tipo) => {
                console.log(tipo);
                return {
                    id: tipo.id,
                    nombre: tipo.nombre,
                    moneda: tipo.moneda,
                    origenDeFondos: tipo.origenDeFondos,
                    sectorDeActividad: tipo.sectorDeActividad,
                    paisDeOperacion: tipo.paisDeOperacion,
                    paisDeResidenciaDelCliente: tipo.paisDeResidenciaDelCliente,
                    paisDeResidenciaDelBeneficiario: tipo.paisDeResidenciaDelBeneficiario,
                    paisDeResidenciaDelRelacionado: tipo.paisDeResidenciaDelRelacionado,
                    pep: tipo.pep,
                    toleranciaAlRiesgo: tipo.toleranciaAlRiesgo
                };
            });
        });

        this.origenDeFondosService.
        getAll(0, 1000).pipe().
        subscribe((req) => {
            this.origenFondos = req.body.map((tipo) => {
                console.log(tipo);
                return {
                    id: tipo.id,
                    nombre: tipo.nombre,
                    factorDeRiesgo: tipo.factorDeRiesgo
                };
            });

        });

    }
    // @Output() eventoDesdePadre: EventEmitter<any> = new EventEmitter<any>();




    loadLocalDataBeneficiario() {
        if (this.LOCAL_DATA.beneficiario != null) {
            if (this.LOCAL_DATA.beneficiarioPersonaFisica != null) {
                this.LOCAL_DATA.beneficiario.tipo = 'PERSONA_FISICA';
                this.LOCAL_DATA.beneficiario.personaFisica =
                    this.LOCAL_DATA.beneficiarioPersonaFisica;
                this.LOCAL_DATA.beneficiario.personaJuridica = null;
            }

            if (this.LOCAL_DATA.beneficiarioPersonaJuridica != null) {
                this.LOCAL_DATA.beneficiario.tipo = 'PERSONA_JURIDICA';
                this.LOCAL_DATA.beneficiario.personaFisica = null;
                this.LOCAL_DATA.beneficiario.personaJuridica =
                    this.LOCAL_DATA.beneficiarioPersonaJuridica;
            }
        }
    }

    clienteChange(cliente: any) {
        if(cliente.id==null && cliente.tipo==null)
            return;
        this.LOCAL_DATA.cliente = cliente;
    }

    beneficiarioChange(cliente: Cliente) {
        this.LOCAL_DATA.beneficiario = cliente;
        if (cliente.tipo == 'PERSONA_FISICA') {
            this.LOCAL_DATA.beneficiarioPersonaFisica = cliente;
        }
        if (cliente.tipo == 'PERSONA_JURIDICA') {
            this.LOCAL_DATA.beneficiarioPersonaJuridica =
                cliente;
        }
    }

    doAction(): void {
        if (this.action != 'Delete') {
            if (
                this.LOCAL_DATA.beneficiario != null &&
                this.LOCAL_DATA.beneficiario.tipo == 'PERSONA_FISICA' &&
                this.LOCAL_DATA.beneficiario.personaFisica != null
            ) {
                this.LOCAL_DATA.beneficiarioPersonaFisica =
                    this.LOCAL_DATA.beneficiario.personaFisica;
            }

            if (
                this.LOCAL_DATA.beneficiario != null &&
                this.LOCAL_DATA.beneficiario.tipo == 'PERSONA_JURIDICA' &&
                this.LOCAL_DATA.beneficiario.personaJuridica != null
            ) {
                this.LOCAL_DATA.beneficiarioPersonaJuridica =
                    this.LOCAL_DATA.beneficiario.personaJuridica;
            }

        }

        this.dialogRef.close({ event: this.action, data: this.LOCAL_DATA });
    }

    loadDocumentsTypes() {
        this.tiposDocumentos = [];
        if (this.razonSocialPais != null) {
            this.serviceTipoDocumento
                .getByCountryAndTypeList(
                    this.razonSocialPais.id,
                    this.LOCAL_DATA.tipo
                )
                .pipe()
                .subscribe((req) => {
                    this.tiposDocumentos = req.body.map((tipo) => {
                        console.log(tipo);
                        return {
                            id: tipo.id,
                            nombre: tipo.nombre,
                            tipo: tipo.tipo,
                        };
                    });
                });
        }
    }

    onTotalCalculoChange(totalCalculo) {
        this.totalCalculo = totalCalculo;
    }

    closeDialog(): void {
        this.dialogRef.close({ event: 'Cancel' });
    }

    openDialogDestinatario(action, obj): void {
        const dialogRef = this.dialog.open(DialogBoxDestinatariosComponent, {
            width: '100%',
            data: { action: action, dataSource: obj },
            disableClose: true,
        });

        dialogRef.afterClosed().subscribe((result) => {
            if (result.event === 'Add') {
                this.addRowData(result.data);
            } else if (result.event === 'Duplicate') {
                this.addRowData(obj);
            } else if (result.event === 'Update') {
                this.updateRowData(result.data);
            } else if (result.event === 'Delete') {
                this.deleteRowData(result.data);
            }
        });
    }

    addRowData(row_obj): void {
        this.LOCAL_DATA.destinatarios.push(row_obj);

        this.LOCAL_DATA.destinatarios = [...this.LOCAL_DATA.destinatarios];
    }

    updateRowData(row_obj): void {
        this.LOCAL_DATA.destinatarios = this.LOCAL_DATA.destinatarios.filter(
            (value, key) => {
                if (value.id === row_obj.id) {
                    value.id = row_obj.id;
                    value.nombre = row_obj.nombre;
                    value.apellido = row_obj.apellido;
                    value.correoElectronico = row_obj.correoElectronico;
                }
                return true;
            }
        );

        this.LOCAL_DATA.destinatarios = [...this.LOCAL_DATA.destinatarios];
    }

    deleteRowData(row_obj): void {
        this.LOCAL_DATA.destinatarios = this.LOCAL_DATA.destinatarios.filter(
            (value, key) => {
                return value.id !== row_obj.id;
            }
        );

        this.LOCAL_DATA.destinatarios = [...this.LOCAL_DATA.destinatarios];
    }

    /// ESTRUCTURA PARA MANEJAR LOS FORMULARIOS

    setFormulario() {
        if (this.LOCAL_DATA.formulario.id != null) {
            this.service
                .get(this.LOCAL_DATA.formulario.id)
                .pipe()
                .subscribe((req) => {
                    this.LOCAL_DATA.formulario = new Formulario(req.body);
                    // this.dataSourceList = data.dataSource;
                    this.orderStructure(this.LOCAL_DATA.formulario.sentencias);
                    this.dataSource.data = [
                        ...this.LOCAL_DATA.formulario.sentencias,
                    ];
                    this.isFormLoaded = true;
                });
        } else {
            this.isFormLoaded = true;
        }
    }

    hasChild = (_: number, node: ExampleFlatNode) => node.expandable;

    ngOnInit(): void {}

    openDialog(action, obj): void {
        obj.action = action;
        obj.info = this.LOCAL_DATA.formulario;
        const dialogRef = this.dialog.open(DialogBoxTreeComponent, {
            width: '100%',
            data: obj,
            disableClose: true,
        });

        dialogRef.afterClosed().subscribe((result) => {
            if (result.event == 'Modifier') {
                this.ngOnInit();
            } else if (result.event != 'Cancel') {
                this.LOCAL_DATA.formulario.sentencias = [...result.data];
                this.dataSource.data = [
                    ...this.LOCAL_DATA.formulario.sentencias,
                ];
            } else {
                this.LOCAL_DATA.formulario.sentencias = [...result.data];
            }
        });
    }

    openSnackBar(message: string, action: string) {
        this._snackBar.open(message, action, {
            duration: 5000,
        });
    }

    orderStructure(sentencias): void {
        if (sentencias != null) {
            for (let z = 0; sentencias.length > z; z++) {
                sentencias.sort(this.utils.sortAlphaNum);
                // sentencias.sort((a, b) => (a.nombre > b.nombre) ? 1 : -1);
                this.orderStructure(sentencias[z].sentencias);
            }
        }
    }

    enviarEventoAlHijo() {
        // Emite un evento al componente hijo
        if (
            this.showNewClient &&
            this.LOCAL_DATA.cliente != null &&
            this.LOCAL_DATA.cliente.id == null
        ) {
            this.eventoDesdePadre = '¡Hola hijo!';
        }
        // this.eventoDesdePadre.emit('¡Hola desde el padre!');
    }

    enviarEventoAlHijoBeneficiario() {
        // Emite un evento al componente hijo
        if (
            this.LOCAL_DATA.beneficiario != null &&
            this.LOCAL_DATA.beneficiario.id == null
        ) {
            this.eventoDesdePadre = '¡Hola hijo!';
        }
        // this.eventoDesdePadre.emit('¡Hola desde el padre!');
    }

    onBlur() {
        // Convierte el valor a un número y luego formatea ese número
        // Usa '1.0-2' para permitir entre 0 y 2 dígitos decimales
        // 'en-US' es el locale, cámbialo según necesites
        this.LOCAL_DATA.monto = this.decimalPipe.transform(
            this.LOCAL_DATA.monto,
            '1.0-2',
            'en-US'
        );
    }

    onFocus() {
        // Convierte el valor formateado de nuevo a un formato editable
        // Elimina los separadores de miles para facilitar la edición
        this.LOCAL_DATA.monto = this.LOCAL_DATA.monto
            .toString()
            .replace(/[,]/g, '');
    }

    compareObjects(o1: any, o2: any): boolean {
        let equals = false;
        if (o1 != null && o2 != null) {
            equals = o1.nombre === o2.nombre && o1.id === o2.id;
        }
        return equals;
    }
}
